// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"271":"04c9f831","791":"41b74e70"}[chunkId] + ".js";
};